import * as React from 'react';
import Styled, { StyledProps } from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { Headline, IHeadlineProps } from '../../../components/Typography';
import { VerMasthead, VerMastHeadIcon, VerMastHeadIntro } from '../VerMasthead';
import { SVGIcon, VALID_SVG_ICONS } from '../../Icon/';

interface ISplashHeadline extends IHeadlineProps {
  // tslint:disable-next-line no-reserved-keywords no-any
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  icon?: VALID_SVG_ICONS;
}

const VerSplashHeadline = Styled(Headline)<ISplashHeadline>`
  margin: 0 auto;

  ${media.large`
    flex-basis: 100%;
    border: 1px solid transparent; /* ie10 flex fix */
  `}
`;

const VerSplashMasthead = Styled(VerMasthead)`
  margin-bottom: 0;

  ${media.medium`
    margin-bottom: 0;
  `}
`;

export const SplashHeadline: React.FunctionComponent<StyledProps<ISplashHeadline>> = ({
  scale,
  as,
  icon,
  children,
  ...rest
}) => (
  <VerSplashMasthead>
    <VerMastHeadIcon {...rest} outset={true}>
       {/* tslint:disable-next-line:no-non-null-assertion */}
      <SVGIcon icon={icon!} />
    </VerMastHeadIcon>
    <VerMastHeadIntro>
      <VerSplashHeadline scale={scale} as={as}>{children}</VerSplashHeadline>
    </VerMastHeadIntro>
  </VerSplashMasthead>
);

SplashHeadline.defaultProps = {
  icon: 'email'
};
